// posterwall® — Theme JS

// ── CART ──
const cartBtn    = document.getElementById('cart-btn');
const cartDrawer = document.getElementById('cart-drawer');
const cartOverlay = document.getElementById('cart-overlay');
const cartClose  = document.getElementById('cart-close');
const cartBody   = document.getElementById('cart-body');
const cartFooter = document.getElementById('cart-footer');
const cartCount  = document.getElementById('cart-count');

function openCart() {
  cartDrawer?.classList.add('on');
  cartOverlay?.classList.add('on');
  document.body.style.overflow = 'hidden';
  fetchCart();
}
function closeCart() {
  cartDrawer?.classList.remove('on');
  cartOverlay?.classList.remove('on');
  document.body.style.overflow = '';
}

cartBtn?.addEventListener('click', openCart);
cartClose?.addEventListener('click', closeCart);
cartOverlay?.addEventListener('click', closeCart);

async function fetchCart() {
  const res  = await fetch('/cart.js');
  const cart = await res.json();
  renderCart(cart);
}

function renderCart(cart) {
  if (!cartBody || !cartFooter) return;
  if (!cart.items.length) {
    cartBody.innerHTML = `
      <div class="cart-empty-state">
        <div class="cart-empty-icon">🛒</div>
        <p>Tu carrito está vacío</p>
        <a href="/collections/all" class="btn-dark" style="margin-top:12px;display:inline-block">Ver productos</a>
      </div>`;
    cartFooter.style.display = 'none';
    return;
  }
  cartBody.innerHTML = cart.items.map((item, index) => `
    <div class="cart-item">
      <div class="cart-item-img">
        ${item.image ? `<img src="${item.image}" alt="${item.title}">` : ''}
      </div>
      <div class="cart-item-info">
        <div class="cart-item-name">${item.product_title}</div>
        <div class="cart-item-variant">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
        <div class="cart-item-qty">
          <button class="qty-btn" onclick="updateQty(${index + 1}, ${item.quantity - 1})">−</button>
          <span class="qty-val">${item.quantity}</span>
          <button class="qty-btn" onclick="updateQty(${index + 1}, ${item.quantity + 1})">+</button>
        </div>
      </div>
      <div class="cart-item-right">
        <button class="cart-item-remove" onclick="updateQty(${index + 1}, 0)" aria-label="Eliminar">✕</button>
        <div class="cart-item-price">${formatMoney(item.final_line_price)}</div>
      </div>
    </div>`).join('');
  const subtotalEl = document.getElementById('cart-subtotal-val');
  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
  if (typeof cartSubtotalCents !== 'undefined') {
    cartSubtotalCents = cart.total_price;
    if (typeof cartSelectedShipping !== 'undefined') cartSelectedShipping = 0;
    const totalRow = document.getElementById('cart-total-row');
    if (totalRow) totalRow.style.display = 'none';
    const shippingResults = document.getElementById('cart-shipping-results');
    if (shippingResults) shippingResults.innerHTML = '';
    const zipInput = document.getElementById('cart-zip-input');
    if (zipInput) zipInput.value = '';
  }
  cartFooter.style.display = '';
  if (cartCount) cartCount.textContent = cart.item_count;
}

async function addToCart(variantId, btn) {
  if (btn) { btn.textContent = 'Agregando...'; btn.disabled = true; }
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });
    if (!res.ok) throw new Error('Error');
    if (btn) { btn.textContent = '✓ Agregado'; setTimeout(() => { btn.textContent = 'Agregar al carrito'; btn.disabled = false; }, 2000); }
    const cartRes = await fetch('/cart.js');
    const cart = await cartRes.json();
    if (cartCount) cartCount.textContent = cart.item_count;
    openCart();
  } catch(e) {
    if (btn) { btn.textContent = 'Error, intentá de nuevo'; btn.disabled = false; }
  }
}

async function updateQty(line, qty) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ line: line, quantity: qty })
  });
  const cartRes = await fetch('/cart.js');
  const cart = await cartRes.json();
  renderCart(cart);
  if (cartCount) cartCount.textContent = cart.item_count;
}

function formatMoney(cents) {
  return '$' + (cents / 100).toLocaleString('es-AR', { minimumFractionDigits: 0 });
}

// ── CHIPS ──
function pickChip(el, group) {
  document.querySelectorAll(`#chips-${group} .chip`).forEach(c => c.classList.remove('active'));
  el.classList.add('active');
}

// ── NAV SCROLL ──
let lastScroll = 0;
window.addEventListener('scroll', () => {
  const nav = document.getElementById('nav');
  if (!nav) return;
  const current = window.scrollY;
  if (current > lastScroll && current > 80) {
    nav.style.transform = 'translateY(-100%)';
  } else {
    nav.style.transform = 'translateY(0)';
  }
  lastScroll = current;
}, { passive: true });

// Nav transition
document.querySelector('.nav')?.style.setProperty('transition', 'transform .3s ease');
